import { render, staticRenderFns } from "./ImportProfile.vue?vue&type=template&id=175c34fd&"
import script from "./ImportProfile.vue?vue&type=script&lang=js&"
export * from "./ImportProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports